import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class AdSettingsService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.visible = new BehaviorSubject(null);
    }
    show() {
        this.visible.next(true);
    }
    hide() {
        this.visible.next(false);
    }
}
AdSettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdSettingsService_Factory() { return new AdSettingsService(i0.ɵɵinject(i0.NgZone)); }, token: AdSettingsService, providedIn: "root" });
